import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTabGroup} from '@angular/material';

import AgreementEventLogsConfig from '../table/configs/eventLogAgreementConfig.json';
import EventLogsConfig from '../table/configs/event-logs.json';
import RefrigeratorEventLogsConfig from '../table/configs/eventLogRefrigeratorConfig.json';
import SalePointEventLogsConfig from '../table/configs/eventLogSalePointConfig.json';

@Component({
  styleUrls: ['./notifications.component.scss'],
  templateUrl: './notifications.component.html'
})
export class NotificationsComponent implements OnInit {
  public config: any;
  public show0: boolean;
  public show1: boolean;
  public show2: boolean;
  public RefrigeratorsConfig: any;
  public SalePointsConfig: any;
  public AgreementsConfig: any;
  @ViewChild('tabs', {static: false}) tabs: MatTabGroup;

  constructor() {
    this.config = JSON.parse(JSON.stringify(EventLogsConfig));
    //#region Refrigerator Table Config
    this.RefrigeratorsConfig = JSON.parse(JSON.stringify(RefrigeratorEventLogsConfig));
    this.RefrigeratorsConfig.nested = true;
    this.RefrigeratorsConfig.filter = 'is_visible = 1';
    //#endregion

    //#region Sale Points Config
    this.SalePointsConfig = JSON.parse(JSON.stringify(SalePointEventLogsConfig));
    this.SalePointsConfig.nested = true;
    this.SalePointsConfig.filter = 'is_visible = 1';
    //#endregion

    //#region Agreements Config
    this.AgreementsConfig = JSON.parse(JSON.stringify(AgreementEventLogsConfig));
    this.AgreementsConfig.nested = true;
    this.AgreementsConfig.filter = 'is_visible = 1';
    //#endregion
  }

  public ngOnInit(): void {
    this.show0 = true;
    this.show1 = false;
    this.show2 = false;
  }

  changeTab(tabs: MatTabGroup): void {
    if (tabs.selectedIndex === 0) {
      this.show0 = true;
      this.show1 = false;
      this.show2 = false;
    }
    if (tabs.selectedIndex === 1) {
      this.show0 = false;
      this.show1 = true;
      this.show2 = false;
    }
    if (tabs.selectedIndex === 2) {
      this.show0 = false;
      this.show1 = false;
      this.show2 = true;
    }
  }
}
